import * as React from "react";
import Layout from "../Layout";
import Content from "./Content";
import { RootState } from "../../store/configureStore";
import InfoLayout from "../UserCenter/components/Layout";
import { useSelector } from "react-redux";

const OrderDetails = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "首页",
      },
      {
        url: "/account/orders/213123123213123",
        title: "订单详情",
      },
    ],
  } = useSelector((state: RootState) => state.OrderDetailsPage);

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <InfoLayout>
        <Content />
      </InfoLayout>
    </Layout>
  );
};

export default OrderDetails;
